/**
 * Badge colour tokens used across the web app.
 *
 * The five tones are the ones defined in `docs/specs-v2/02-ecrans.md` §0
 * (gris / bleu / vert / orange / rouge). The web app maps a tone to concrete
 * Tailwind classes; it must never hard-code a French label or pick a colour by
 * itself — every status registry below carries both.
 */
export const BADGE_TONES = ['gray', 'blue', 'green', 'orange', 'red'];
/** French label of a status code. */
export function statusLabel(registry, code) {
    return registry[code].label;
}
/** Badge tone of a status code. */
export function statusTone(registry, code) {
    return registry[code].tone;
}
/** All entries of a registry, in declaration order — handy for filter dropdowns. */
export function statusEntries(registry) {
    return Object.values(registry);
}
//# sourceMappingURL=badge.js.map